// extracted by mini-css-extract-plugin
module.exports = {"container":"_1JRdkHpboKQBikrP1s77Cc","headerHolder":"_3BmsIwc-X1U0dFPU92FPR8","info":"_2Vj7p7uideoZUKkMTSDz0S","curtain":"_2fTp8u8N04URl78HrfOyxq"};